export enum SETUP_STORE_ID {
  AUTH = 'auth-store',
  CORE = 'core-store',
  PRODUCT = 'product-store',
  ROUTER = 'router-store',
  TAB = 'tab-store',
  THEME = 'theme-store',
}
